"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiregistrationController = exports.UIParticipantStatus = exports.SubparticipantStatus = exports.ObjectId = void 0;
const immer_1 = require("immer");
const emitter_1 = require("../emitter");
(0, immer_1.setAutoFreeze)(false);
const ObjectId = (m = Math, d = Date, h = 16, s = ss => m.floor(ss).toString(h)) => s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));
exports.ObjectId = ObjectId;
var SubparticipantStatus = /*#__PURE__*/function (SubparticipantStatus) {
  SubparticipantStatus["PENDING_ASSIGNMENT"] = "PENDING_ASSIGNMENT";
  SubparticipantStatus["CANCELLED"] = "CANCELLED";
  SubparticipantStatus["ASSIGNED"] = "ASSIGNED";
  return SubparticipantStatus;
}(SubparticipantStatus || (exports.SubparticipantStatus = SubparticipantStatus = {}));
var UIParticipantStatus = /*#__PURE__*/function (UIParticipantStatus) {
  UIParticipantStatus["PENDING_ASSIGNMENT"] = "PENDING_ASSIGNMENT";
  UIParticipantStatus["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
  UIParticipantStatus["CANCELLED"] = "CANCELLED";
  UIParticipantStatus["CONFIRMED"] = "CONFIRMED";
  UIParticipantStatus["SCANNED"] = "SCANNED";
  return UIParticipantStatus;
}(UIParticipantStatus || (exports.UIParticipantStatus = UIParticipantStatus = {}));
class MultiregistrationController extends emitter_1.Emitter {
  _config;
  _eventID;
  _cartData = null;
  _initialSubparticipantIds = [];
  _uiState = {
    error: undefined,
    main_participant: {
      id: '',
      ticket_type_id: null,
      participant_attributes: {},
      editable: true,
      ticket_options: [],
      is_main: true,
      status: UIParticipantStatus.PENDING_ASSIGNMENT,
      scanned: false,
      error: undefined
    },
    subparticipants: [],
    can_add_participant: false,
    total_unassigned_slots: 0
  };
  constructor(eventID, config) {
    super();
    this._eventID = eventID;
    this._config = config;
  }
  getUIState() {
    return {
      subscribe: listener => {
        return this.on('update', listener);
      },
      getState: () => this._uiState
    };
  }
  getSubmissionPayload() {
    const allParticipants = [...(this._uiState.main_participant ? [this._uiState.main_participant] : []), ...this._uiState.subparticipants];
    return {
      mainparticipant_ticket_type_id: this._uiState.main_participant?.ticket_type_id || null,
      subparticipants: allParticipants.filter(p => !p.is_main && p.ticket_type_id !== null && p.ticket_type_id !== '').map(p => ({
        _id: this._initialSubparticipantIds.includes(p.id) ? p.id : undefined,
        ticket_type_id: p.ticket_type_id,
        participant_attributes: p.participant_attributes
      }))
    };
  }
  _toUIParticipant(subparticipant, draft) {
    const ret = {
      id: subparticipant?._id || (0, exports.ObjectId)(),
      ticket_type_id: subparticipant?.ticket_type_id || null,
      participant_attributes: subparticipant?.participant_attributes || {},
      editable: true,
      ticket_options: this._getAvailableTicketOptions(draft),
      is_main: subparticipant?.is_main || false,
      status: UIParticipantStatus.PENDING_ASSIGNMENT,
      scanned: subparticipant?.scanned || false,
      error: undefined
    };
    switch (subparticipant?.status) {
      case SubparticipantStatus.PENDING_ASSIGNMENT:
        ret.status = UIParticipantStatus.PENDING_CONFIRMATION;
        break;
      case SubparticipantStatus.CANCELLED:
        ret.status = UIParticipantStatus.CANCELLED;
        ret.ticket_type_id = null;
        break;
      case SubparticipantStatus.ASSIGNED:
        ret.status = UIParticipantStatus.CONFIRMED;
        break;
      default:
        ret.status = UIParticipantStatus.PENDING_ASSIGNMENT;
        break;
    }
    if (subparticipant?.scanned) {
      ret.status = UIParticipantStatus.SCANNED;
      ret.editable = false; // Scanned participants cannot be edited
      ret.ticket_options = [];
    }
    return ret;
  }
  hasErrors() {
    return !!(this._uiState.error || this._uiState.main_participant?.error || this._uiState.subparticipants.some(sub => sub.error));
  }
  initialize(payload, cartResult) {
    this._cartData = cartResult;
    this._initialSubparticipantIds = payload.subparticipants.map(sub => sub._id);
    this._mutateAndEmit(draft => {
      // Find main participant
      const mainParticipant = payload.subparticipants.find(sub => sub.is_main);
      draft.main_participant = this._toUIParticipant(mainParticipant || {
        is_main: true
      }, draft);
      // Set subparticipants
      draft.subparticipants = payload.subparticipants.filter(sub => !sub.is_main).map(sub => {
        const ret = this._toUIParticipant(sub, draft);
        ret.is_main = false;
        return ret;
      });
      this._updateTicketOptions(draft);
      draft.error = this._validateState(draft);
    });
  }
  setCartData(cartResult) {
    this._cartData = cartResult;
    this._mutateAndEmit(draft => {
      this._updateTicketOptions(draft);
      draft.error = this._validateState(draft);
    });
  }
  updateParticipant(id, attributes) {
    this._mutateAndEmit(draft => {
      const participant = draft.main_participant?.id === id ? draft.main_participant : draft.subparticipants.find(p => p.id === id);
      if (participant) {
        participant.participant_attributes = {
          ...participant.participant_attributes,
          ...attributes
        };
      }
      draft.error = this._validateState(draft);
    });
  }
  addParticipant(attributes) {
    this._mutateAndEmit(draft => {
      const newParticipant = this._toUIParticipant({
        participant_attributes: attributes,
        is_main: false
      }, draft);
      if (this._config.multiregistration_type === 'group') {
        newParticipant.ticket_type_id = this._eventID;
        newParticipant.status = UIParticipantStatus.PENDING_CONFIRMATION;
      }
      draft.subparticipants.push(newParticipant);
      draft.error = this._validateState(draft);
    });
  }
  removeParticipant(id) {
    this._mutateAndEmit(draft => {
      const index = draft.subparticipants.findIndex(p => p.id === id);
      if (index < 0) {
        return; // Participant not found, nothing to remove
      }
      if (this._initialSubparticipantIds.includes(id)) {
        draft.subparticipants[index].status = UIParticipantStatus.CANCELLED;
        draft.subparticipants[index].ticket_type_id = null;
      } else {
        draft.subparticipants = draft.subparticipants.filter(p => p.id !== id);
      }
      draft.error = this._validateState(draft);
    });
  }
  setMainParticipantTicket(ticketTypeId) {
    this._mutateAndEmit(draft => {
      if (draft.main_participant.ticket_type_id === ticketTypeId) {
        return;
      }
      draft.main_participant.ticket_type_id = ticketTypeId;
      if (ticketTypeId === null) {
        draft.main_participant.status = UIParticipantStatus.PENDING_ASSIGNMENT;
      } else {
        draft.main_participant.status = UIParticipantStatus.PENDING_CONFIRMATION;
      }
      this._updateTicketOptions(draft);
      draft.error = this._validateState(draft);
      return draft;
    });
  }
  setSubParticipantTicket(id, ticketTypeId) {
    this._mutateAndEmit(draft => {
      const participant = draft.subparticipants.find(p => p.id === id);
      if (!participant || !participant?.editable) {
        return;
      }
      if (participant.ticket_type_id === ticketTypeId) {
        return; // No change
      }
      participant.ticket_type_id = ticketTypeId;
      if (ticketTypeId === null) {
        participant.status = UIParticipantStatus.PENDING_ASSIGNMENT;
      } else {
        participant.status = UIParticipantStatus.PENDING_CONFIRMATION;
      }
      this._updateTicketOptions(draft);
      draft.error = this._validateState(draft);
    });
  }
  _getTicketTypeCounts(draft) {
    const ticketCounts = new Map();
    if (this._config.multiregistration_type === 'ticket') {
      if (!this._cartData) return [];
      this._cartData.condensedItems.forEach(item => {
        if (item.product.type === 'ticket' && item.product.id) {
          ticketCounts.set(item.product.id, {
            label: item.product_name || item.product.id,
            count: (ticketCounts.get(item.product.id)?.count || 0) + item.quantity
          });
        }
      });
    } else {
      // For group type, create a virtual ticket type
      ticketCounts.set(this._eventID, {
        label: 'Registration',
        count: this._config.multiregistration_limit
      });
    }
    const assignedCounts = new Map();
    // Count from UI state
    const allParticipants = [...(draft.main_participant ? [draft.main_participant] : []), ...draft.subparticipants];
    allParticipants.forEach(participant => {
      if (participant.ticket_type_id && participant.ticket_type_id !== '') {
        assignedCounts.set(participant.ticket_type_id, (assignedCounts.get(participant.ticket_type_id) || 0) + 1);
      }
    });
    return Array.from(ticketCounts.entries()).map(([ticketTypeId, ticketInfo]) => ({
      ticket_type_id: ticketTypeId,
      available: ticketInfo.count,
      assigned: assignedCounts.get(ticketTypeId) || 0,
      label: ticketInfo.label
    }));
  }
  _getAvailableTicketOptions(draft) {
    const ticketCounts = this._getTicketTypeCounts(draft);
    // Add "No ticket" option first
    const options = [{
      label: 'No ticket assigned',
      value: null
    }];
    // Add available tickets
    options.push(...ticketCounts.filter(tc => tc.assigned < tc.available).map(tc => ({
      label: tc.label,
      value: tc.ticket_type_id
    })));
    return options;
  }
  _updateTicketOptions(draft) {
    const availableOptions = this._getAvailableTicketOptions(draft);
    const ticketCounts = this._getTicketTypeCounts(draft);
    // Helper function to get options for a participant including their current ticket
    const getOptionsForParticipant = currentTicketId => {
      if (!currentTicketId) {
        return availableOptions;
      }
      // Check if current ticket is already in available options
      const hasCurrentTicket = availableOptions.some(opt => opt.value === currentTicketId);
      if (hasCurrentTicket) {
        return availableOptions;
      }
      // Add current ticket to options even if not available for new assignments
      const currentTicketInfo = ticketCounts.find(tc => tc.ticket_type_id === currentTicketId);
      const currentTicketOption = {
        label: currentTicketInfo?.label || currentTicketId,
        value: currentTicketId
      };
      return [availableOptions[0], currentTicketOption, ...availableOptions.slice(1)];
    };
    if (draft.main_participant) {
      draft.main_participant.ticket_options = getOptionsForParticipant(draft.main_participant.ticket_type_id);
    }
    draft.subparticipants.forEach(participant => {
      if (participant.editable) {
        participant.ticket_options = getOptionsForParticipant(participant.ticket_type_id);
      } else {
        participant.ticket_options = [];
      }
    });
  }
  _validateState(draft) {
    const ticketCounts = this._getTicketTypeCounts(draft);
    const exceededTicket = ticketCounts.find(tc => tc.assigned > tc.available);
    if (exceededTicket) {
      return {
        code: 'TICKETS_EXCEEDED',
        message: this._config.multiregistration_type === 'group' ? `Too many participants assigned. Group limit is ${exceededTicket.available}, but ${exceededTicket.assigned} are assigned.` : `Too many tickets assigned for "${exceededTicket.label}". Available: ${exceededTicket.available}, Assigned: ${exceededTicket.assigned}.`
      };
    }
    if (this._config.mainparticipant_assigned_required && !draft.main_participant?.ticket_type_id) {
      return {
        code: 'MAIN_PARTICIPANT_TICKET_REQUIRED',
        message: this._config.multiregistration_type === 'group' ? 'Main participant must be assigned to a slot' : 'Main participant must have a ticket assigned'
      };
    }
    if (!this._config.unassigned_tickets_allowed) {
      const totalAvailable = ticketCounts.reduce((sum, tc) => sum + tc.available, 0);
      const totalAssigned = ticketCounts.reduce((sum, tc) => sum + tc.assigned, 0);
      if (totalAssigned < totalAvailable) {
        return {
          code: 'UNASSIGNED_TICKETS_NOT_ALLOWED',
          message: this._config.multiregistration_type === 'group' ? `All ${totalAvailable} group slots must be assigned to participants` : `All ${totalAvailable} purchased tickets must be assigned to participants`
        };
      }
    }
    if (this._config.multiregistration_type === 'group') {
      const activeParticipants = draft.subparticipants.filter(p => p.ticket_type_id !== null && p.ticket_type_id !== '').length + (draft.main_participant?.ticket_type_id ? 1 : 0);
      const maxParticipants = this._config.multiregistration_type === 'group' ? this._config.multiregistration_limit : ticketCounts.reduce((sum, tc) => sum + tc.available, 0);
      draft.can_add_participant = activeParticipants < maxParticipants;
    } else {
      draft.can_add_participant = ticketCounts.some(tc => tc.assigned < tc.available);
    }
    draft.total_unassigned_slots = ticketCounts.reduce((sum, tc) => sum + (tc.available - tc.assigned), 0);
    return undefined;
  }
  _mutateAndEmit(recipie) {
    this._uiState = (0, immer_1.produce)(this._uiState, recipie);
    this.emit('update');
  }
}
exports.MultiregistrationController = MultiregistrationController;
